import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, Auth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

let app;
let auth: Auth;
let storage;

if (firebaseConfig.apiKey) {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  auth = getAuth(app);
  storage = getStorage(app);

  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      console.log("[Firebase] Auth initialized with Local Persistence.");
    })
    .catch((err) => {
      console.error("[Firebase] Auth Persistence failed:", err);
    });
} else {
  console.warn("[Firebase] VITE_FIREBASE_API_KEY is missing. Firebase Auth initialized in dummy state.");
  auth = null as any;
  storage = null as any;
}

export { auth, storage };

